import * as actionTypes from '../action-types';
import { SearchActions, QueryParamsActions } from '../actions';

export type LayoutReducerType = {
  userHasStartedToSearch: boolean;
  hideSearch: boolean;
  marketingLogged: boolean;
};

const defaultState: LayoutReducerType = {
  userHasStartedToSearch: false,
  hideSearch: false,
  marketingLogged: false,
};

const startSearch = (state: LayoutReducerType) => ({
  ...state,
  userHasStartedToSearch: true,
});

export function layoutReducer(
  state: LayoutReducerType = defaultState,

  action: SearchActions | QueryParamsActions,
) {
  switch (action.type) {
    case actionTypes.SYNC_QUERY_RESPONSE: {
      return startSearch(state);
    }
    case actionTypes.UPDATE_QUERY: {
      return startSearch(state);
    }
    case actionTypes.SEARCH_REQUEST: {
      return startSearch(state);
    }
    default: {
      return state;
    }
  }
}
